/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteTenantWithRealmInput = {
    tenantId: string;
};
export type Tenants_deleteTenant_MutationVariables = {
    input: DeleteTenantWithRealmInput;
};
export type Tenants_deleteTenant_MutationResponse = {
    readonly deleteTenantWithRealm: {
        readonly tenant: {
            readonly id: string;
        };
    } | null;
};
export type Tenants_deleteTenant_Mutation = {
    readonly response: Tenants_deleteTenant_MutationResponse;
    readonly variables: Tenants_deleteTenant_MutationVariables;
};



/*
mutation Tenants_deleteTenant_Mutation(
  $input: DeleteTenantWithRealmInput!
) {
  deleteTenantWithRealm(input: $input) {
    tenant {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTenantWithRealmPayload",
    "kind": "LinkedField",
    "name": "deleteTenantWithRealm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Tenant",
        "kind": "LinkedField",
        "name": "tenant",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Tenants_deleteTenant_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Tenants_deleteTenant_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4e844eeacdc63ee65c98b2593fdefa20",
    "id": null,
    "metadata": {},
    "name": "Tenants_deleteTenant_Mutation",
    "operationKind": "mutation",
    "text": "mutation Tenants_deleteTenant_Mutation(\n  $input: DeleteTenantWithRealmInput!\n) {\n  deleteTenantWithRealm(input: $input) {\n    tenant {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '327aa99f426c9f15f3bdddfa85be0a0b';
export default node;
